export class GrupoCompra {
  Id: number;
  GrupoProdutoId: number;
  Descricao:string = "";
  ResponsavelId: number;
  EmpresaInternaId: number;

  DataCadastro:  Date;
}
